import React, { Component } from "react";
import "./CampaignDetailsTab.css";
import { fetchMethod } from "../../../FetchMethod";
import { campaignDetails } from "../../../Queries";
import Linkify from "react-linkify";
class CampaignDetailsTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      name: "",
      description: "",
      customer: "",
      campManagerFirstName: "",
      campManagerLastName: "",
      campAdminFirstName: "",
      campAdminLastName: "",
      linkedInProfile: "",
      status: "",
      connectionsToBeSent: "",
      startDate: "",
      startTime: "",
      steps: [],
      show: false,
      opencontact: "",
    };
  }
  componentDidMount() {
    this.fetchDetails(this.props.campaignId);
  }

  fetchDetails = (campaignId) => {
    fetchMethod(campaignDetails(campaignId))
      .then((response) => {
        return response.json();
      })
      .then((responseAsJson) => {
        this.setState(
          {
            loading: false,
            show: true,
          },
          () => this.props.detailEdit(this.state.show)
        );
        this.setDetails(responseAsJson);
      })
      .catch((e) => {
        console.log(e);
        this.setState({ loading: true });
      });
  };

  setTimeZone = (startTime) => {
    let timezones = [
      { name: "PST", value: "-28800" },
      { name: "MST/PDT", value: "-25200" },
      { name: "CST/MDT", value: "-21600" },
      { name: "EST/CDT", value: "-18000" },
      { name: "EDT", value: "-14400" },
      { name: "GMT", value: "0" },
      { name: "BST", value: "+3600" },
      { name: "IST", value: "+19800" },
    ];
    let stime = "";
    timezones.map((t) => {
      if (t.value === startTime) {
        stime = t.name;
      }
    });
    this.setState({ startTime: stime });
  };

  setDetails = (response) => {
    let customer =
      response.data.Campaigns.customerIbfk1rel !== undefined
        ? response.data.Campaigns.customerIbfk1rel.Customers.map((c) => {
            return c.company;
          })
        : "";
    let campAdminFirstName =
      response.data.Campaigns.Admin !== undefined
        ? response.data.Campaigns.Admin.Usersdata.map((fname) => {
            return fname.name;
          })
        : "";

    let campManagerFirstName =
      response.data.Campaigns.Manager !== undefined &&
      response.data.Campaigns.Manager !== null
        ? response.data.Campaigns.Manager.Usersdata.map((name) => {
            let fname =
              name.firstName !== undefined && name.firstName !== null
                ? name.firstName
                : "";
            let lname =
              name.lastName !== undefined && name.lastName !== null
                ? name.lastName
                : "";
            return fname + " " + lname;
          })
        : "";

    let linkedInProfile =
      response.data.Campaigns.customercredentialsIbfk1rel
        .Customerlinkedinprofiles !== undefined &&
      response.data.Campaigns.customercredentialsIbfk1rel
        .Customerlinkedinprofiles !== null
        ? response.data.Campaigns.customercredentialsIbfk1rel.Customerlinkedinprofiles.map(
            (name) => {
              return name.name;
            }
          )
        : "";
    this.setTimeZone(response.data.Campaigns.timezone);

    this.setState(
      {
        name: response.data.Campaigns.name,
        description: response.data.Campaigns.description,
        customer: customer,
        campAdminFirstName: campAdminFirstName,
        campManagerFirstName: campManagerFirstName,
        linkedInProfile: linkedInProfile,
        status: response.data.Campaigns.status,
        connectionsToBeSent: response.data.Campaigns.targetconnections,
        // connectionsToBeSent: response.data.Campaigns.zapierurl,
        startDate: response.data.Campaigns.startdate,
        steps:
          response.data.Campaigns.Campaignstepfk !== undefined
            ? response.data.Campaigns.Campaignstepfk.Campaignsteps
            : "",
        opencontact: response.data.Campaigns.opencontact,
      },
      () => {
        this.state.steps.sort(function (a, b) {
          return a.sequence - b.sequence;
        });
        this.props.name(this.state.name);
      }
    );
  };
  render() {
    const {
      name,
      description,
      customer,
      // campAdminFirstName,
      // campAdminLastName,
      linkedInProfile,
      status,
      startDate,
      connectionsToBeSent,
      // startTime,
      steps,
    } = this.state;

    let Status = status !== null ? status : "";
    let StartDate = startDate.split("T")[0];
    let date = StartDate.split("-").reverse().join("/");
    let dateArray = date.split("/");
    let reverseDate =
      dateArray[0] !== ""
        ? dateArray[0] + "/" + dateArray[1] + "/" + dateArray[2]
        : "";
    let StartTime = startDate.split("T")[1];
    let reverseTime =
      StartTime !== undefined && StartTime !== null
        ? StartTime.split(".")[0]
        : "";
    let time =
      reverseTime !== undefined && reverseTime !== null
        ? reverseTime.split(":")
        : "";
    let Timestart =
      time[0] !== undefined && time[1] !== undefined
        ? time[0] + ":" + time[1]
        : "";

    const campaignManager = this.state.campManagerFirstName;

    let pos = 0;
    return (
      <div className="CampaignDetails">
        <div className="topDiv">
          <div>
            <h5>{"Name & Description"}</h5>
            <p>{name !== null && name !== " " && name ? name : "--"}</p>
          </div>
          <div>
            <p>
              {description !== null && description !== " " && description
                ? description
                : "--"}
            </p>
          </div>
        </div>
        <div className="midDivs">
          <div className="midDiv1">
            <p>
              {customer !== null && customer !== " " && customer
                ? customer
                : "--"}
            </p>
          </div>
          <div className="midDiv3">
            <p>
              {campaignManager !== null &&
              campaignManager !== " " &&
              campaignManager
                ? campaignManager
                : "--"}
            </p>
          </div>
          <div className="midDiv4">
            <p>
              {linkedInProfile !== null &&
              linkedInProfile !== " " &&
              linkedInProfile
                ? linkedInProfile
                : "--"}
            </p>
          </div>
          <div className="midDiv5">
            <p>
              {Status !== null && Status !== " " && Status ? (
                Status.toLowerCase() === "live" ? (
                  <span className="live">{Status}</span>
                ) : Status.toLowerCase() === "paused" ? (
                  <span className="paused">{Status}</span>
                ) : Status.toLowerCase() === "completed" ? (
                  <span className="completed">{Status}</span>
                ) : (
                  <span className="notstarted">{Status}</span>
                )
              ) : (
                "--"
              )}
            </p>
          </div>
          <div className="midDiv6">
            <p>
              {connectionsToBeSent !== null &&
              connectionsToBeSent !== " " &&
              connectionsToBeSent
                ? connectionsToBeSent
                : "--"}
            </p>
          </div>
          <div className="midDiv7">
            <p>
              {reverseDate !== null &&
              reverseDate !== "" &&
              reverseDate !== undefined &&
              Timestart !== null &&
              Timestart !== "" &&
              Timestart !== undefined
                ? reverseDate + " " + Timestart
                : "--"}
            </p>
          </div>
        </div>
        <div className="steps">{steps.length > 0 ? "Standard Steps" : " "}</div>
        <div className={"bottomDivs"}>
          {steps.map((step, key) => {
            if (step.open === 0) {
              // const count = key + 1;
              const count = step.sequence;
              let stepclass =
                step.stepname === "SEND_INVITE"
                  ? `sendInvite`
                  : step.stepname === "FOLLOW"
                  ? `follow`
                  : step.stepname === "VISIT"
                  ? `visit`
                  : step.stepname === "SEND_THANKS_MESSAGE"
                  ? `sendThanks`
                  : step.stepname === "SEND_MESSAGE"
                  ? `sendMessage`
                  : step.stepname === "SEND_EMAIL"
                  ? `sendMessage`
                  : "";
              if (step.stepname === "SEND_MESSAGE" || "SEND_EMAIL") {
                pos = pos + 1;
              }
              return (
                <div className={stepclass} key={key}>
                  <p>
                    <b>
                      {step.stepname === "SEND_INVITE"
                        ? count + ". Send Invite"
                        : step.stepname === "FOLLOW"
                        ? count + ". Follow Profile"
                        : step.stepname === "VISIT"
                        ? count + ". Visit Profile"
                        : step.stepname === "SEND_THANKS_MESSAGE"
                        ? count + ". Send Thanks Message"
                        : step.stepname === "SEND_MESSAGE"
                        ? count + ". Send Message "
                        : step.stepname === "SEND_EMAIL"
                        ? count + ". Send InMail"
                        : ""}
                    </b>
                  </p>
                  {step.stepname === "SEND_MESSAGE" ||
                  step.stepname === "SEND_EMAIL" ||
                  step.stepname === "SEND_THANKS_MESSAGE" ||
                  step.stepname === "SEND_INVITE" ? (
                    step.message !== null &&
                    step.message !== " " &&
                    step.message ? (
                      <p>
                        <Linkify>{step.message}</Linkify>
                      </p>
                    ) : (
                      <p>--</p>
                    )
                  ) : (
                    ""
                  )}
                  <p>
                    {step.limitperday !== null &&
                    step.limitperday !== " " &&
                    step.limitperday
                      ? step.limitperday
                      : "--"}{" "}
                    {step.stepname === "SEND_MESSAGE" ? (
                      <span>message per day ~ </span>
                    ) : step.stepname === "SEND_INVITE" ? (
                      <span>invite per day ~ </span>
                    ) : step.stepname === "FOLLOW" ? (
                      <span>follow per day ~ </span>
                    ) : step.stepname === "SEND_THANKS_MESSAGE" ? (
                      <span>thanks message per day ~ </span>
                    ) : step.stepname === "SEND_EMAIL" ? (
                      <span>email per day ~ </span>
                    ) : (
                      <span>visit per day ~ </span>
                    )}
                    {step.daysdelay !== null &&
                    step.daysdelay !== " " &&
                    step.daysdelay
                      ? step.daysdelay
                      : "0"}{" "}
                    days delay
                  </p>
                </div>
              );
            }
          })}
        </div>
        {this.state.opencontact !== 0 && (
          <div className="Open steps">
            {steps.length > 0 ? "Open Steps" : " "}
          </div>
        )}
        <div className={"bottomDivs"}>
          {steps.map((step, key) => {
            if (step.open === 1) {
              const count = step.sequence;
              // const count = key + 1;
              let stepclass =
                step.stepname === "SEND_INVITE"
                  ? `sendInvite`
                  : step.stepname === "FOLLOW"
                  ? `follow`
                  : step.stepname === "VISIT"
                  ? `visit`
                  : step.stepname === "SEND_THANKS_MESSAGE"
                  ? `sendThanks`
                  : step.stepname === "SEND_MESSAGE"
                  ? `sendMessage`
                  : step.stepname === "SEND_EMAIL"
                  ? `sendMessage`
                  : "";
              if (step.stepname === "SEND_MESSAGE" || "SEND_EMAIL") {
                pos = pos + 1;
              }
              return (
                <div className={stepclass} key={key}>
                  <p>
                    <b>
                      {step.stepname === "SEND_INVITE"
                        ? count + ". Send Invite"
                        : step.stepname === "FOLLOW"
                        ? count + ". Follow Profile"
                        : step.stepname === "VISIT"
                        ? count + ". Visit Profile"
                        : step.stepname === "SEND_THANKS_MESSAGE"
                        ? count + ". Send Thanks Message"
                        : step.stepname === "SEND_MESSAGE"
                        ? count + ". Send Message "
                        : step.stepname === "SEND_EMAIL"
                        ? count + ". Send InMail"
                        : ""}
                    </b>
                  </p>
                  {step.stepname === "SEND_MESSAGE" ||
                  step.stepname === "SEND_EMAIL" ||
                  step.stepname === "SEND_THANKS_MESSAGE" ||
                  step.stepname === "SEND_INVITE" ? (
                    step.message !== null &&
                    step.message !== " " &&
                    step.message ? (
                      <p>
                        <Linkify>{step.message}</Linkify>
                      </p>
                    ) : (
                      <p>--</p>
                    )
                  ) : (
                    ""
                  )}
                  <p>
                    {step.limitperday !== null &&
                    step.limitperday !== " " &&
                    step.limitperday
                      ? step.limitperday
                      : "--"}{" "}
                    {step.stepname === "SEND_MESSAGE" ? (
                      <span>message per day ~ </span>
                    ) : step.stepname === "SEND_INVITE" ? (
                      <span>invite per day ~ </span>
                    ) : step.stepname === "FOLLOW" ? (
                      <span>follow per day ~ </span>
                    ) : step.stepname === "SEND_THANKS_MESSAGE" ? (
                      <span>thanks message per day ~ </span>
                    ) : step.stepname === "SEND_EMAIL" ? (
                      <span>email per day ~ </span>
                    ) : (
                      <span>visit per day ~ </span>
                    )}
                    {step.daysdelay !== null &&
                    step.daysdelay !== " " &&
                    step.daysdelay
                      ? step.daysdelay
                      : "0"}{" "}
                    days delay
                  </p>
                </div>
              );
            }
          })}
        </div>
      </div>
    );
  }
}

export default CampaignDetailsTab;
